module.exports = __webpack_public_path__ + "static/profile-fa384ad18e2ef5307172942ffacbb8b4.jpg";